/**
 * Recipe totals. Mirrors _finalize_recipe in app/blueprints/api/sync.py, so a
 * recipe edited offline shows the same numbers the server will store.
 *
 * With a cooked weight, per-100 g is per 100 g of the FINISHED dish — so a
 * portion weighed out of the pot is logged exactly, whatever water boiled off.
 */

import { add, per100From, scale, type Nutrients } from './nutrients.ts'

export type Ingredient = { name: string; brand?: string | null; grams: number; per100: Nutrients;
  source?: string | null; source_ref?: string | null }

export function recipeTotals(ingredients: Ingredient[], servings: number, cookedWeightG?: number | null) {
  const totals: Nutrients = {}
  let grams = 0
  for (const i of ingredients) {
    if (!i.grams || i.grams <= 0) continue
    add(totals, scale(i.per100, i.grams))
    grams += i.grams
  }
  const basis = cookedWeightG && cookedWeightG > 0 ? cookedWeightG : grams
  const s = servings > 0 ? servings : 1
  const perServing: Nutrients = {}
  for (const [k, v] of Object.entries(totals)) perServing[k as keyof Nutrients] = Math.round((v / s) * 1000) / 1000
  return {
    totals,
    totalGrams: grams,
    per100: basis ? per100From(totals, basis) : null,
    perServing,
    servingGrams: basis ? basis / s : null,
  }
}
